module.exports = __webpack_public_path__ + "static/Touchless_MonthTwo-31-3f549eee3b005edba609759ce6aa9466.jpg";